// extracted by mini-css-extract-plugin
export default {"inbox":"Inbox__inbox--yM3","icon":"Inbox__icon--2e2"};